var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control",attrs:{"type":"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }